import { Injectable, inject } from '@angular/core';
import { BisualSettingService } from '../services/bisual-setting.service';
import { UtilsService } from '../services/utils.service';

@Injectable({ providedIn: 'root' })
export class BisualSettingInitializedGuard {
  private readonly bisual_setting = inject(BisualSettingService);
  protected readonly utils = inject(UtilsService);

  async canActivate(): Promise<boolean> {
    await this.isBisualSettingsInitialized();
    return true;
  }

  private async isBisualSettingsInitialized(): Promise<boolean> {
    if (this.bisual_setting.getSettings() != null) {
      return true;
    }

    await this.utils.sleep(500);
    return await this.isBisualSettingsInitialized();
  }
}
